import { NgModule } from '@angular/core';

import { PortfolioDisplayDatePipe } from './pipes/portfolio-display-date.pipe';
import { PortfolioNamePipe } from './pipes/portfolio-name.pipe';

@NgModule({
	declarations: [
		PortfolioDisplayDatePipe,
		PortfolioNamePipe
	],
	exports: [
		PortfolioDisplayDatePipe,
		PortfolioNamePipe
	]
})
export class PortfolioDataModule { }
